import {connect} from '../../app/connect';
import IssuePreviewModal from './IssuePreviewModal';
import {getGalleryIsOpen, getIssuesCollectionLoading} from '../../app/selectors';

const mapStateToProps = state => ({
  attachmentGalleryIsOpen: getGalleryIsOpen(state),
  isIssuesCollectionLoading: getIssuesCollectionLoading(state)
});

export default connect(mapStateToProps)(IssuePreviewModal);
